// extracted by css-extract-rspack-plugin
export default {"wrapper":"W66vr7Bu6VIO2jcn","inner":"H4Z4DkGXG4EJSFSi","left":"SdZoTbuCTWoVyzzP","medium":"w9bJz3X9nD8nTeRg","right":"NK3Kc0hbszsVayoG","closeButton":"WcZ9vmzov9Y2OMVx"};